/*
  坐标转换：

  WGS84坐标系:天地图（CGCS2000坐标，跟WGS84两者容差cm级别），谷歌地图
  火星坐标系GCJ02：高德地图
  公司后台存的是火星坐标系GCJ02
*/
var PI = 3.14159265358979324;
var a = 6378245.0; 
var ee = 0.00669342162296594323; 

export function gcj02ToWgs(lng, lat) {//火星坐标 -> WGS84
  var lat1 = +lat;
  var lng1 = +lng;
  var dlat = transformLat(lng1 - 105.0, lat1 - 35.0);
  var dlng = transformLon(lng1 - 105.0, lat1 - 35.0);
  var radlat = lat1 / 180.0 * PI;
  var magic = Math.sin(radlat);
  magic = 1 - ee * magic * magic;
  var sqrtmagic = Math.sqrt(magic);
  dlat = (dlat * 180.0) / ((a * (1 - ee)) / (magic * sqrtmagic) * PI);
  dlng = (dlng * 180.0) / (a / sqrtmagic * Math.cos(radlat) * PI);
  var mglat = lat1 + dlat;
  var mglng = lng1 + dlng;
  var lngLat = [];
  lngLat[0] = lng1 * 2 - mglng;
  lngLat[1] = lat1 * 2 - mglat;
  return lngLat;
}

export function tianMapLngLat(lng, lat) {//天地图坐标
  return new T.LngLat(gcj02ToWgs(lng, lat)[0], gcj02ToWgs(lng, lat)[1])
}

export function wgsToGcj(wgLon,wgLat){//WGS84 -> 火星坐标
  var mars_point={lon:0,lat:0};
  if (outOfChina(wgLon,wgLat)){
    mars_point.lat = wgLat;
    mars_point.lon = wgLon;
    return;
  }
  var dLat = transformLat(wgLon - 105.0, wgLat - 35.0);
  var dLon = transformLon(wgLon - 105.0, wgLat - 35.0);
  var radLat = wgLat / 180.0 * PI;
  var magic = Math.sin(radLat);
  magic = 1 - ee * magic * magic;
  var sqrtMagic = Math.sqrt(magic);
  dLat = (dLat * 180.0) / ((a * (1 - ee)) / (magic * sqrtMagic) * PI);
  dLon = (dLon * 180.0) / (a / sqrtMagic * Math.cos(radLat) * PI);
  mars_point.lat = wgLat + dLat;
  mars_point.lon = wgLon + dLon;
  return [mars_point.lon,mars_point.lat]
}
function outOfChina(lon, lat){//判断是否在国内，不在国内则不做偏移
  if ((lon < 72.004 || lon > 137.8347)&&(lat < 0.8293 || lat > 55.8271)){
    return true;
  }else {
    return false;
  }
}
function transformLat (x, y) {
  var ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
  ret += (20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0 / 3.0;
  ret += (20.0 * Math.sin(y * PI) + 40.0 * Math.sin(y / 3.0 * PI)) * 2.0 / 3.0;
  ret += (160.0 * Math.sin(y / 12.0 * PI) + 320 * Math.sin(y * PI / 30.0)) * 2.0 / 3.0;
  return ret;
}
function transformLon (x, y) {
  var ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
  ret += (20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0 / 3.0;
  ret += (20.0 * Math.sin(x * PI) + 40.0 * Math.sin(x / 3.0 * PI)) * 2.0 / 3.0;
  ret += (150.0 * Math.sin(x / 12.0 * PI) + 300.0 * Math.sin(x / 30.0 * PI)) * 2.0 / 3.0;
  return ret;
}